import { useMemo } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { TopupsApiAdapter } from '../adapters';
import {
    CreateTopupPayload,
    ApproveTopupPayload,
    RejectTopupPayload,
} from '../models';
import { TOPUPS_QUERY_KEY } from './useTopups';

export const useTopupsMutations = () => {
    const queryClient = useQueryClient();
    const httpClient = useMemo(() => createHttpClient(apiClientWH), []);
    const apiAdapter = useMemo(() => new TopupsApiAdapter(httpClient), [httpClient]);

    const invalidateList = () => {
        queryClient.invalidateQueries({ queryKey: [TOPUPS_QUERY_KEY] });
    };

    const createMutation = useMutation({
        mutationFn: ({ walletId, payload }: { walletId: number; payload: CreateTopupPayload }) =>
            apiAdapter.createTopup(walletId, payload),
        onSuccess: invalidateList,
    });

    const approveMutation = useMutation({
        mutationFn: ({ id, payload }: { id: number; payload?: ApproveTopupPayload }) =>
            apiAdapter.approveTopup(id, payload),
        onSuccess: invalidateList,
    });

    const rejectMutation = useMutation({
        mutationFn: ({ id, payload }: { id: number; payload: RejectTopupPayload }) =>
            apiAdapter.rejectTopup(id, payload),
        onSuccess: invalidateList,
    });

    return {
        createTopup: createMutation,
        approveTopup: approveMutation,
        rejectTopup: rejectMutation,
    };
};

